<script setup>

import { ref, onMounted } from "vue";

import http from "@/axios-config";
import { useUserState } from "@/stores/user-state";

import Button from "../Button.vue";

const userStore = useUserState();

const emit = defineEmits(['newUser']);

const props = defineProps({
    userProp: {
        type: Object,
        default: null,
    },
});

const editing = ref(false);

const user = ref({});

onMounted(() => {
    if (props.userProp) {
        user.value = props.userProp;
        Object.assign(user, props.userProp);

        editing.value = true;
    }
})

async function saveUser() {
    const response = await http.post("/api/users/create", user.value);

    userStore.users.push(response.data);

    if (response.status === 200) {
        emit('newUser');
    }
}

async function editUser() {
    const response = await http.post(`/api/users/${user.value.id}/update`, user.value);

    if (response.data.success) {
        props.userProp = user.value;
    }
}
</script>

<template>
    <h1 v-if="!editing">Add user</h1>
    <h1 v-else>Edit user</h1>
    <div>
        <label for="">Name</label>
        <input type="text" v-model="user.name">
    </div>
    <div>
        <label for="">Email</label>
        <input type="text" v-model="user.email">
    </div>
    <div>
        <label for="">New password</label>
        <input type="password" v-model="user.password">
    </div>
    <Button :method="saveUser" v-if="!editing">Add user</Button>
    <Button :method="editUser" v-else>Save changes</Button>
</template>
